import React, { PureComponent, ReactNode } from 'react';

import Button from '@atlaskit/button';
import DropdownMenu from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';

type MoreMenuProps = {
  children: ReactNode;
  label: string;
};

export default class MoreMenu extends PureComponent<MoreMenuProps> {
  render() {
    const { children, label } = this.props;

    return (
      <DropdownMenu
        placement="bottom-end"
        spacing="compact"
        trigger={({ triggerRef, ...props }) => (
          <Button
            {...props}
            iconBefore={<MoreIcon label={label} />}
            appearance="subtle"
            ref={triggerRef}
          />
        )}
      >
        {children}
      </DropdownMenu>
    );
  }
}
